import { Col, DatePicker, Form, InputNumber, Row, Select, Switch } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import React, { Component } from 'react';

const formTailLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};
export enum AutoGroupRule {
  NOT_ALLOWED,
  ALLOW_ROBOT,
  ALLOW_UNDERFILL,
}

export enum ChangeGroupRule {
  NOT_ALLOWED,
  ONLY_ONE,
  UNLIMITED,
}

export enum UserLimited {
  ANY,
  PAID,
  NOT_PAY,
}

interface Props {
  form: WrappedFormUtils;
}

interface State {}

export class AddSaleType extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Form>
          <Row gutter={24}>
            <Col span={14}>
              <Form.Item label="团购价格" {...formTailLayout}>
                {getFieldDecorator('total', {
                  rules: [
                    {
                      required: true,
                      message: '请输入团购价格',
                    },
                  ],
                })(<InputNumber placeholder="" />)}
              </Form.Item>
              <Form.Item label="最小成团数" {...formTailLayout}>
                {getFieldDecorator('minSize', {
                  rules: [
                    {
                      required: true,
                      message: '请输入最小成团数',
                    },
                  ],
                })(<InputNumber placeholder="" />)}
              </Form.Item>
              <Form.Item label="拼团用户限制" {...formTailLayout}>
                {getFieldDecorator('userLimited', {
                  rules: [
                    {
                      required: true,
                      message: '请选限制择拼团用户',
                    },
                  ],
                })(
                  <Select placeholder="请选限制择拼团用户" style={{ width: 188 }}>
                    <Select.Option key="any" value={UserLimited.ANY}>
                      全部用户
                    </Select.Option>
                    <Select.Option key="notPay" value={UserLimited.NOT_PAY}>
                      未支付
                    </Select.Option>
                    <Select.Option key="paid" value={UserLimited.PAID}>
                      已支付
                    </Select.Option>
                  </Select>,
                )}
              </Form.Item>
              <Form.Item label="自动成团规则" {...formTailLayout}>
                {getFieldDecorator('autoGroupRule', {
                  rules: [
                    {
                      required: true,
                      message: '请选择成团规则',
                    },
                  ],
                })(
                  <Select placeholder="请选择成团规则" style={{ width: 188 }}>
                    <Select.Option key="allowRobot" value={AutoGroupRule.ALLOW_ROBOT}>
                      自动成团
                    </Select.Option>
                    <Select.Option key="allowUnderfill" value={AutoGroupRule.ALLOW_UNDERFILL}>
                      不成团时自动成团
                    </Select.Option>
                    <Select.Option key="notAllowed" value={AutoGroupRule.NOT_ALLOWED}>
                      不自动成团
                    </Select.Option>
                  </Select>,
                )}
              </Form.Item>
              <Form.Item label="转团规则" {...formTailLayout}>
                {getFieldDecorator('changeGroupRule', {
                  rules: [
                    {
                      required: true,
                      message: '请选择转团规则',
                    },
                  ],
                })(
                  <Select placeholder="请选择转团规则" style={{ width: 188 }}>
                    <Select.Option key="allowRobot" value={ChangeGroupRule.NOT_ALLOWED}>
                      不允许转团
                    </Select.Option>
                    <Select.Option key="onlyOne" value={ChangeGroupRule.ONLY_ONE}>
                      只允许一人使用
                    </Select.Option>
                    <Select.Option key="unlimited" value={ChangeGroupRule.UNLIMITED}>
                      不限制
                    </Select.Option>
                  </Select>,
                )}
              </Form.Item>
              <Form.Item {...formTailLayout} label="拼团开始时间">
                {getFieldDecorator('startAt', {
                  rules: [
                    {
                      required: true,
                      message: '请选择拼团开始时间',
                    },
                  ],
                })(<DatePicker />)}
              </Form.Item>
              <Form.Item {...formTailLayout} label="拼团结束时间">
                {getFieldDecorator('endAt', {
                  rules: [
                    {
                      required: true,
                      message: '请填写拼团结束时间',
                    },
                  ],
                })(<DatePicker />)}
              </Form.Item>
              <Form.Item label="拼团时效" {...formTailLayout}>
                {getFieldDecorator('duration', {
                  rules: [
                    {
                      required: true,
                      message: '请输入拼团时效',
                    },
                  ],
                })(<InputNumber placeholder="" />)}
              </Form.Item>
              <Form.Item label="是否显示团购列表" {...formTailLayout}>
                {getFieldDecorator('isListDisplayed', { initialValue: false })(<Switch />)}
              </Form.Item>
              <Form.Item label="是否开团" {...formTailLayout}>
                {getFieldDecorator('isActive', { initialValue: false })(<Switch />)}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/stock/AddSaleType.tsx